import { hasTimePanelSelectedCalendars } from './hasTimePanelSelectedCalendars';
import { getStore } from '../store/store';
import { ObservableMap } from 'mobx';
import { getSelectedCalendars as getSelectedCalendarsFromCalendarModule } from 'owa-calendar-module-selected-calendars-user-config';
import { dedupeObservableMapValues } from 'owa-selected-calendars-utils';

export function getTimePanelSelectedCalendarIdsMap(): ObservableMap<string, string[]> {
    if (hasTimePanelSelectedCalendars()) {
        return dedupeObservableMapValues(getStore().calendarIdsMap);
    } else {
        // if time panel selected calendars have not been set, fall back to showing the calendar modules selected calendars
        return getSelectedCalendarsFromCalendarModule();
    }
}
